
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton as singleton_1, isEmpty, ofArray, empty, tryFind, choose } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { formatReminderInterval } from "../../../Common.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog } from "../../../Components/Dialog.js";
import { Msg } from "./Types.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledValue } from "../../../Components/Text.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function InspectionTemplateDetail(props) {
    let matchValue_1, elems_2, Title, elems_1, elems;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const categoryNames = join(", ", choose((catId) => map((_arg) => _arg.Name, tryFind((c) => (c.Id.fields[0] === catId), props.Categories)), props.Template.CategoryIds));
    const intervalText = formatReminderInterval(t, props.Template.Interval, props.Template.CustomInterval);
    let notificationText;
    const matchValue = props.Template.NotificationInterval;
    if (matchValue == null) {
        notificationText = t("inspection_template.notification_disabled");
    }
    else {
        const notificationInterval = matchValue;
        notificationText = (`${notificationInterval.Value} ${t((matchValue_1 = notificationInterval.Interval, (matchValue_1 === "week") ? "custom_interval_before.weeks" : ((matchValue_1 === "month") ? "custom_interval_before.months" : ((matchValue_1 === "year") ? "custom_interval_before.years" : "custom_interval_before.days"))))}`);
    }
    return reactElement("div", createObj(singleton_1((elems_2 = [createElement(ConfirmationDialog, (Title = t("inspection_template.delete_title"), {
        Description: t("inspection_template.delete_confirmation"),
        FormState: props.FormState,
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(3, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_1 = [createElement(DetailViewHeader, {
        Badges: empty(),
        OnBack: () => {
            RouterModule_nav(ofArray(["inspection-templates"]), 1, 1);
        },
        OnDelete: unwrap(props.Template.IsUsed ? undefined : (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        })),
        OnEdit: () => {
            RouterModule_nav(ofArray(["inspection-templates", props.Template.Id, "edit"]), 1, 1);
        },
        Title: props.Template.Name,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "gap-4", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems = toList(delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.name"),
        Value: props.Template.Name,
    })), delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.description"),
        Value: props.Template.Description,
    })), delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.interval"),
        Value: intervalText,
    })), delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.notification_interval"),
        Value: notificationText,
    })), delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.successful_results"),
        Value: join(", ", props.Template.SuccessfulResults),
    })), delay(() => append(singleton(LabeledValue({
        Label: t("inspection_template.failed_results"),
        Value: join(", ", props.Template.FailedResults),
    })), delay(() => append(!isEmpty(props.Template.CategoryIds) ? singleton(LabeledValue({
        Label: t("inspection_template.categories"),
        Value: categoryNames,
    })) : empty_1(), delay(() => (props.Template.IsUsed ? singleton(reactElement("div", {
        className: join(" ", ["text-sm", "text-text-muted", "italic"]),
        children: t("inspection_template.is_used_hint"),
    })) : empty_1()))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

export function DetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.TemplateId), update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Template;
    const matchValue_1 = state_1.Categories;
    let matchResult, categories, template;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 0;
            categories = matchValue_1.fields[0];
            template = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return createElement(InspectionTemplateDetail, {
                Categories: categories,
                Dispatch: patternInput[1],
                FormState: state_1.FormState,
                Template: template,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

